import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { CrdShellComponent } from './crd-shell/crd-shell.component';
import { ErrorPageComponent } from './error-page/error-page.component';

export function noPortalMatcher(url: UrlSegment[]) {
  return { consumed: url };
}

const routes: Routes = [
  { path: '', component: CrdShellComponent },
  {
    path: 'token/:token',
    children: [
      {
        path: 'language/:language',
        loadChildren: () =>
          import('./crd-shell/crd-shell.routes').then((m) => m.Routes)
      },
      {
        path: 'crd/:crd/plantation-table/:plantationTable',
        component: CrdShellComponent
      }
    ]
  },
  { path: 'error', component: ErrorPageComponent },
  {
    matcher: noPortalMatcher,
    redirectTo: '/error?status=404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
